const NavTwitterIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0801 2.66675H21.9187C26.3538 2.66675 29.3334 5.78534 29.3334 10.4281V21.572C29.3334 26.2134 26.3524 29.3334 21.9173 29.3334H10.0801C5.6464 29.3334 2.66675 26.2134 2.66675 21.572V10.4281C2.66675 5.78534 5.6464 2.66675 10.0801 2.66675ZM23.0545 8.80008H20.601L16.5582 13.4214L13.0627 8.80008H8.00008L14.0491 16.71L8.31603 23.2626H10.771L15.1957 18.2067L19.0628 23.2626H24.0001L17.6944 14.9263L23.0545 8.80008ZM21.0994 21.7941H19.7399L10.8651 10.1914H12.324L21.0994 21.7941Z"
        fill="url(#paint0_linear_15183_166103)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15183_166103"
          x1="16.0001"
          y1="2.66675"
          x2="16.0001"
          y2="29.3334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#89B8F0" />
          <stop offset="1" stopColor="#165BAD" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default NavTwitterIcon
